// ts-prune-ignore-next-line
export { MetaData } from './MetaData';
